import type { TPageTranslations } from '@crehana/i18n';

import { CREATE_AND_EDIT_EMAIL_TEMPLATES } from './constants';
import type { TKeys } from './types';

export const pt: TPageTranslations<
  TKeys,
  typeof CREATE_AND_EDIT_EMAIL_TEMPLATES
> = {
  [CREATE_AND_EDIT_EMAIL_TEMPLATES]: {
    DAY: 'dia',
    DAYS: 'dias',
    SUCCESS_TITLE_CREATE_TEMPLATE: 'Modelo criado com sucesso',
    TOAST_TITLE_CREATE_TEMPLATE_ERROR: 'Erro ao criar o modelo',
    SUCCESS_TITLE_RESET: 'Modelo restaurado com sucesso',
    TOAST_TITLE_RESET_ERROR: 'Erro ao restaurar o modelo',
    RECRUITMENT: 'Recrutamento',
    CONFIGURATION: 'Configuração',
    EMAIL_TEMPLATES: 'Modelos de e-mail',
    TEMPLATE_DETAIL: 'Detalhes do modelo',
    NEW_TEMPLATE: 'Novo modelo',
    CANCEL: 'Cancelar',
    ADD_NAME_TEMPLATE: 'Adicione um nome ao modelo',
    IN_DRAFT: 'Em rascunho',
    TITLE_SCHEDULE_SHIPMENT: 'Agendar envio',
    FIRST_DESCRIPTION_SCHEDULE_SHIPMENT:
      'Use esta opção para notificar o candidato de que ele não continuará no processo um ou mais dias após sua rejeição. O e-mail será enviado apenas em dias úteis (segunda a sexta-feira).',
    SECOND_DESCRIPTION_SCHEDULE_SHIPMENT:
      '*Se não estiver ativado, o envio será automático após a rejeição.',
    NUMBER_OF_DAYS: 'Número de dias',
    SHIPPING_TIME: 'Horário de envio',
    RESTORE_TEMPLATE: 'Restaurar modelo',
    SEND_TEST_EMAIL: 'Enviar e-mail de teste',
    SAVE_AND_EXIT: 'Salvar e sair',
    TITLE_RESTORE_TEMPLATE: 'Deseja restaurar o modelo?',
    DESCRIPTION_RESTORE_TEMPLATE:
      'Todas as alterações feitas serão perdidas e o conteúdo voltará ao estado padrão.',
    YES_RESTORE: 'Sim, restaurar',
    LOADING_TEXT: 'Restaurando...',
    TITLE_TEST_MAIL_SENDING: 'Deseja enviar um e-mail de teste?',
    DESCRIPTION_TEST_MAIL_SENDING:
      'Lembre-se de que o e-mail será enviado para:',
    YES_SEND: 'Sim, enviar',
    TITLE_UNSAVED_CHANGES: 'Você tem alterações não salvas. Deseja sair?',
    DESCRIPTION_UNSAVED_CHANGES: 'Todas as alterações feitas serão perdidas.',
    EXIT_WITHOUT_SAVING: 'Sair sem salvar',
    BACK_TO_EDITING: 'Não, voltar à edição',
    NOTIFICATION_REEMPLACE: 'Substituir imagem',
    NOTIFICATION_IMAGE_SIZE:
      'Tamanho: 600 x 192 px, Máx: 2 MB, Formato: PNG, JPG',
    NOTIFICATION_LOADING: 'Carregando...',
    NOTIFICATION_PROGRESS_LABEL: 'Carregando imagem...',
    NOTIFICATION_ERROR_NUMBER_FILES:
      'Você pode carregar até {{MAX_FILES}} arquivos.',
    NOTIFICATION_ERROR_SIZE: 'O arquivo não atende aos requisitos de tamanho',
    SUBJECT_EMAIL: 'Assunto do e-mail',
    REQUIRED_SUBJECT: '(Obrigatório)',
    NOTIFICATION_SUBMIT_PLACEHOLDER: 'Insira um assunto',
    PLACEHOLDER_SUBJECT_EMAIL: 'Preencher campo',
    UPLOAD_ATTACHMENT: 'Carregar anexo',
    MAX_ATTACHMENTS_SIZE: '(Máx. 3 arquivos, peso máx: 20MB)',
    NOTIFICATION_ERROR_LABEL: 'Erro ao carregar o arquivo',
    NOTIFICATION_ERROR_EXTENSION: 'O arquivo não atende ao formato exigido',
    NOTIFICATION_RETRY: 'Tentar novamente',
    USER_DIALOG_DELETE_BUTTON_CANCEL: 'Cancelar',
    NOTIFICATION_ATTACHMENT_RETRY: 'Tentar novamente',
    FILE_SIZE_ERROR: 'O arquivo não atende aos requisitos de tamanho',
    ERROR_UPLOAD_FILE: 'Erro ao carregar o arquivo',
    NOTIFICATION_DRAG_IMAGE: 'Arraste sua imagem para carregá-la ou',
    NOTIFICATION_CHOOSE_FILE: 'escolha seu arquivo',
    NOTIFICATION_TITLE_PLACEHOLDER: 'Insira um título',
    NOTIFICATION_TEXTAREA_PLACEHOLDER: 'Escreva o corpo da mensagem',
    MAX_LENGTH_TITLE: 'Máximo de 58 caracteres',
    NAME_EMPLOYEE: '{NAME_EMPLOYEE}',
    NAME_ORGANIZATION: '{NAME_ORGANIZATION}',
    NAME_VACANCY: '{NAME_VACANCY}',
    NAME_EMPLOYEE_LABEL: 'Nome do empregado',
    NAME_ORGANIZATION_LABEL: 'Nome da organização',
    NAME_VACANCY_LABEL: 'Nome da vaga',
    DELETE_FILE: 'Excluir',
    UPLOADING_FILE: 'Carregando arquivo',
    SUCCESS_TITLE_SEND_TEST_EMAIL: 'O e-mail de teste foi enviado com sucesso.',
    SUCCESS_DESCRIPTION_SEND_TEST_EMAIL:
      'Verifique sua caixa de correio ou pasta de spam.',
    FILE_EXTENSION_ERROR: 'O arquivo não atende ao formato exigido',
    FILE_PREVIEW_ERROR: 'Erro ao criar o preview do arquivo',
    TOAST_TITLE_SEND_TEST_EMAIL_ERROR: 'Erro ao enviar o e-mail de teste',
    TOAST_DESCRIPTION_SEND_TEST_EMAIL_ERROR:
      'Por favor, tente novamente mais tarde.',
    LOADING_TEXT_SEND_TEST_EMAIL: 'Enviando...',
    UPLOAD_DOCUMENTS: 'Carregar documentos',
  },
};
